// extracted by mini-css-extract-plugin
module.exports = {"compareSection":"CompareSection_compareSection__3EKwy","carsGrid":"CompareSection_carsGrid__3SRmG"};